import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { Form } from 'src/utils/form';
import { capitalizeFirstLetter } from 'src/utils/string';
import http from 'src/services/httpService';
import SvgIcon from 'src/componentes/svg-icon';
import LucideIcon from 'src/componentes/lucide-icon';
import Chip from 'src/componentes/chip';
import Tooltip from 'src/componentes/tooltip';
import moment from 'moment';

class FiltroChip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFilter: this.props.modelValue
        ? this.props.modelValue
        : this.props.selectedFilter,
      updateProps: false,
      showLeftArrow: false,
      showRightArrow: true,
    };

    this.form = new Form({ component: this, schema: this.props.searchSchema });
    this.divScroll = React.createRef();
  }

  componentDidMount() {
    this.checkScroll();
  }

  componentDidUpdate(prevProps) {
    const { selectedFilter } = this.props;

    if (prevProps.selectedFilter != selectedFilter) {
      this.setState({
        selectedFilter: selectedFilter,
      });
      this.checkScroll();
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.selectedFilter)
      this.setState({ selectedFilter: newProps.selectedFilter });
  }

  selectCampoTabela(opcoesTabela, objFiltragem) {
    if (Array.isArray(objFiltragem))
      return opcoesTabela.filter(
        (opcaoTabela) =>
          objFiltragem.filter(({ id }) => opcaoTabela.id == id).length
      );

    return opcoesTabela.filter(
      (opcaoTabela) => opcaoTabela.id.toString() == objFiltragem
    );
  }

  isCampoCustomizado(field) {
    return field.toLowerCase().includes('camposcustomizados');
  }

  handleLabel(obj, index, selectedFilter, check, indexCampo) {
    let { intl, resources, idioma, locale } = this.props;
    let label = '';

    let objectIndex = Object.keys(selectedFilter);

    let field =
      indexCampo != null ? objectIndex[indexCampo] : objectIndex[index];

    const customLabel = this.props.getFilterChipLabel?.(field, obj);
    if (customLabel != null) return customLabel;

    let model = this.form.getModel(field);

    let labelObject = model && model.label;

    let campoCustomizado =
      this.isCampoCustomizado(field) &&
      selectedFilter[field] &&
      selectedFilter[field][index] &&
      selectedFilter[field][index].descricaoCampo;

    let finalLabel =
      labelObject && labelObject.props
        ? labelObject.props.id
          ? labelObject.props.id
          : 'label.a'
        : campoCustomizado;

    let termo = labelObject ? false : true;

    if (obj.nome != null) {
      label = obj.nome;
    } else if (obj.descricao != null) {
      label = obj.descricao;
    } else if (obj.legenda != null) {
      label = obj.legenda;
    } else if (typeof obj == 'string') {
      label = obj;
    } else if (this.isCampoCustomizado(field)) {
      if (obj.campo.opcoesTabela != null && obj.campo.opcoesTabela.length > 0) {
        let campoTabela = [];

        if (
          obj.campo &&
          (obj.campo.multiSelecao === true || obj.campo.multiSelecao === 'true')
        ) {
          campoTabela = this.selectCampoTabela(
            obj.campo.opcoesTabela,
            obj.campo.valores
          );
        } else {
          campoTabela = this.selectCampoTabela(
            obj.campo.opcoesTabela,
            obj.valor
          );
        }

        label =
          campoTabela.length > 0 &&
          campoTabela.map(({ descricao }) => descricao).join('; ');

        return obj.campo.nome + ': ' + label;
      }

      return obj.campo.nome + ': ' + obj.valor;
    } else if (obj.length > 0) {
      if (obj[0].nome) label = obj.map((x) => x.nome).join(', ');
      else if (obj[0].descricao) label = obj.map((x) => x.descricao).join(', ');
      else if (obj[0].legenda) label = obj.map((x) => x.legenda).join(', ');
      else
        obj.map(
          (x) =>
            (label =
              x.campo != null && x.valor != ''
                ? x.campo.nome
                : label === ''
                ? x.nome
                : label + ', ' + x.nome)
        );
    } else if (Object.prototype.toString.call(obj) === '[object Date]') {
      const fieldName = objectIndex[indexCampo ?? index];

      if (fieldName === 'ano') {
        label = moment(obj).format('YYYY');
      } else {
        const newLocale = locale || idioma || 'pt-BR';

        label = obj.toLocaleDateString(newLocale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      }
    } else if (typeof obj == 'number') {
      label = '' + obj;
    }

    if (objectIndex[index] == 'id' || objectIndex[index] == 'altered') {
      return;
    }

    const objArray = Array.isArray(obj);

    if (termo) {
      const path = resources[this.form.getModel(objectIndex[index]).path];
      if (label && path)
        return check
          ? capitalizeFirstLetter(path)
          : capitalizeFirstLetter(path) + ': ' + label;
      else if (objectIndex && objectIndex[index])
        switch (objectIndex[index]) {
          case 'cicloAvaliacao':
            return check
              ? capitalizeFirstLetter(resources.cicloavaliacao)
              : capitalizeFirstLetter(resources.cicloavaliacao) + ': ' + label;
          case 'areasSubordinadas':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'areasSubordinadas' },
                { areas: resources.areas }
              )
            );
          case 'areasGeradorasSubordinadas':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.considerarAreasSubordinadas' },
                { areas: intl.formatMessage({ id: 'areasGeradoras' }) }
              )
            );
          case 'considerarAreasSubordinadas':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.considerarAreasSubordinadas' },
                { areas: resources.areas }
              )
            );
          case 'areasSubordinadasControle':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'areasSubordinadas' },
                  { areas: resources.areas }
                )
              ) +
              ' - ' +
              capitalizeFirstLetter(resources.pontodecontrole)
            );
          case 'areaSubordinada':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.areaSubordinada' },
                { area: resources.area }
              )
            );
          case 'digitador':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'digitador' },
                { digitador: resources.digitador }
              )
            );
          case 'perdasOperacionais':
            return (
              capitalizeFirstLetter(resources.perdasoperacionais) + ': ' + label
            );
          case 'pesquisasClima':
            return capitalizeFirstLetter(resources.pesquisas) + ': ' + label;
          case 'categoriasDicionarioRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelCategoriaDicionarioRisco' },
                  { riscos: resources.riscos }
                )
              ) +
              ': ' +
              label
            );
          case 'statusRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelStatusRisco' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'ocultarParametros':
            return capitalizeFirstLetter(resources.parametros);
          case 'usarCorFarolRealizado':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'usarCorFarolRealizado' },
                { realizado: resources.valorrealizado }
              )
            );
          case 'tipoTeste':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelTipoTeste' }) +
                ': ' +
                obj.descricao
            );
          case 'filtrarAcoesEspelho':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'filtrarAcoesEspelho' },
                { acoes: resources.acoes }
              )
            );
          case 'areaColaboradores':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'label.colaboradoresArea' },
                  {
                    colaboradores: resources.colaboradores,
                    area: resources.area,
                  }
                )
              ) +
              ': ' +
              label
            );
          case 'pontoControle':
            return capitalizeFirstLetter(
              resources.pontodecontrole + ': ' + obj.descricao
            );
          case 'apenasAcoesModuloAtual':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.apenasAcoesModuloAtual' },
                { acoes: resources.acoes }
              )
            );
          case 'exibirAcoesComoMembroEquipe':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelConsiderarResponsavelNaEquipe' },
                { acoes: resources.acoes }
              )
            );
          case 'considerarAcoesMembroEquipe':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelExibirAcoesComoMembroEquipe' },
                { acoes: resources.acoes }
              )
            );
          case 'somenteAcoesFilhas':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelSomenteAcoesFilhas' },
                { acoes: resources.acoes }
              )
            );
          case 'apenasAcoesOrigem':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.apenasAcoesOrigem' },
                { acoes: resources.acoes }
              )
            );
          case 'tipoRisco':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'tipo' })) +
              ': ' +
              obj.descricao
            );
          case 'matrizRisco':
          case 'filtroMatrizRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'matrizRisco' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              obj.descricao
            );
          case 'modeloRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'utilizarModelo' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              obj.descricao
            );
          case 'grauRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'grauRisco' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              (obj.descricao ? obj.descricao : `Id (${obj.id})`)
            );
          case 'grausRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'grauRisco' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              label
            );
          case 'riscoAtrelado':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelRiscoAtrelado' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              (obj.descricao ? obj.descricao : `Id (${obj.id})`)
            );
          case 'grausRiscoInerente':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelGrauRiscoInerente' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              label
            );
          case 'grausRiscoResidual':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelGrauRiscoResidual' },
                  { risco: resources.risco }
                )
              ) +
              ': ' +
              label
            );
          case 'severidadeInerente':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelSeveridadeInerente' },
                  { severidade: resources.severidade }
                )
              ) +
              ': ' +
              label
            );
          case 'severidadeResidual':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelSeveridadeResidual' },
                  { severidade: resources.severidade }
                )
              ) +
              ': ' +
              label
            );
          case 'probabilidadeInerente':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelProbabilidadeInerente' },
                  { probabilidade: resources.probabilidade }
                )
              ) +
              ': ' +
              label
            );
          case 'probabilidadeResidual':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelProbabilidadeResidual' },
                  { probabilidade: resources.probabilidade }
                )
              ) +
              ': ' +
              label
            );
          case 'toleranciaRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelToleranciaRisco' },
                  {
                    risco: resources.risco,
                  }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'toleranciaRiscoFaixas':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelToleranciaRiscoFaixas' },
                  {
                    risco: resources.risco,
                  }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'causasRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelCausasDoRisco' },
                  {
                    pontosproblematicos: resources.pontosproblematicos,
                    risco: resources.risco,
                  }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'consequenciasRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelConsequenciasDoRisco' },
                  {
                    consequencias: resources.consequencias,
                    risco: resources.risco,
                  }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'areas':
            return (
              capitalizeFirstLetter(resources.areas) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.nome;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'processos':
            return (
              capitalizeFirstLetter(resources.processos) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.nome;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'tipoPontoControle':
            return (
              intl.formatMessage(
                { id: 'labelTipoPontoDeControle' },
                { pontodecontrole: resources.pontodecontrole }
              ) +
              ': ' +
              obj.descricao
            );
          case 'aging':
            return intl.formatMessage({ id: 'aging' }) + ': ' + obj.descricao;
          case 'responsavel':
            return capitalizeFirstLetter(
              resources.responsavel + ': ' + obj.nome
            );
          case 'tipoAcao':
            return `${capitalizeFirstLetter(
              intl.formatMessage(
                { id: objectIndex[index] },
                { acao: resources.acao }
              )
            )}: ${obj.descricao}`;
          case 'incluirSubprocessos':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'incluirSubprocessos' },
                {
                  processosfilhosplural:
                    resources.processosfilhosplural.toLowerCase(),
                }
              )
            );
          case 'tema':
            return capitalizeFirstLetter(
              resources.temaestrategico + ': ' + obj.descricao
            );
          case 'responsaveisProjeto':
            return (
              capitalizeFirstLetter(resources.responsaveisprojeto) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.nome;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'funcaoPontoControle':
            return (
              intl.formatMessage(
                { id: 'funcaoPontoControle' },
                { pontodecontrole: resources.pontodecontrole }
              ) +
              ': ' +
              obj.descricao
            );
          case 'frequenciaControle':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.frequencia' })
              ) +
              ': ' +
              obj.descricao
            );
          case 'nivelAcao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'nivelAcao' },
                  { acao: resources.acao }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'criadorAcao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'criadorAcao' },
                  { acao: resources.acao }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.nome;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'dataCriacaoAcao':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'dataCriacaoAcao' },
                { acao: resources.acao }
              )
            );
          case 'statusAprovacao':
            return capitalizeFirstLetter(intl.formatMessage({ id: 'status' }));
          case 'listaStatus':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'status' })) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'acaoCadastradaAprovacao':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'acaoCadastradaAprovacao' },
                { acao: resources.acao, acoes: resources.acoes }
              )
            );
          case 'projeto':
            return check
              ? capitalizeFirstLetter(resources.projeto)
              : capitalizeFirstLetter(resources.projeto) + ': ' + label;

          case 'listaDesempenho':
            return (
              capitalizeFirstLetter(resources.desempenho) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );

          case 'listaFarois':
            return (
              capitalizeFirstLetter(resources.farol) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.legenda;
                      })
                      .join(', ')
                  : obj.legenda
                : '')
            );

          case 'listaFaroisAcumulados':
            return (
              capitalizeFirstLetter(resources.farolAcumulado) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.legenda;
                      })
                      .join(', ')
                  : obj.legenda
                : '')
            );

          case 'statusAvaliacao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'statusAvaliacao' },
                  { avaliacao: resources.avaliacao }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );
          case 'statusAvaliacoes':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'statusAvaliacao' },
                  { avaliacao: resources.avaliacao }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );

          case 'farolPontoControle':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'farolPontoControle' },
                  { pontodecontrole: resources.pontodecontrole }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );

          case 'tipoFiltroData':
            return (
              intl.formatMessage({ id: 'label.tipoFiltroData' }) +
              ': ' +
              obj.descricao
            );

          case 'tipoFiltroDataCriacaoAcao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'tipoFiltroDataCriacaoAcao' },
                  { acao: resources.acao }
                )
              ) +
              ': ' +
              obj.descricao
            );

          case 'tipoFiltroDataRegistroPerdaOperacional':
            return (
              intl.formatMessage({ id: 'labelPeriodoDataRegistro' }) +
              ': ' +
              obj.descricao
            );

          case 'tipoFiltroDataPeriodoPerdaOperacional':
            return (
              intl.formatMessage({ id: 'labelPeriodoDataPerda' }) +
              ': ' +
              obj.descricao
            );

          case 'templatesPerdaOperacional':
            return (
              intl.formatMessage(
                { id: 'templateAnalisePerda' },
                { perdaoperacional: resources.perdaoperacional }
              ) +
              ': ' +
              label
            );

          case 'dataInicialCriacaoAcao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'dataInicialCriacaoAcao' },
                  { acao: resources.acao }
                )
              ) +
              ': ' +
              moment(obj).format('DD/MM/YYYY')
            );

          case 'dataFinalCriacaoAcao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'dataFinalCriacaoAcao' },
                  { acao: resources.acao }
                )
              ) +
              ': ' +
              moment(obj).format('DD/MM/YYYY')
            );

          case 'tipoFiltroDataPeriodoCSA':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'tipoFiltroDataPeriodoCSA' })
              ) +
              ': ' +
              obj.descricao
            );

          case 'dataInicialPeriodoCSA':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'dataInicialPeriodoCSA' })
              ) +
              ': ' +
              moment(obj).format('MM/YYYY')
            );

          case 'dataFinalPeriodoCSA':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'dataFinalPeriodoCSA' })
              ) +
              ': ' +
              moment(obj).format('MM/YYYY')
            );

          case 'tipoPeriodoDataInicio':
            if (obj && Number(obj.id) === 1) return;
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataInicio' })
              ) +
              ': ' +
              obj.descricao
            );

          case 'dataInicioDe':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataInicio' })
              ) +
              ' - ' +
              intl.formatMessage({ id: 'deDataInicial' }) +
              ': ' +
              moment(obj).format('MM/YYYY')
            );

          case 'dataInicioAte':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataInicio' })
              ) +
              ' - ' +
              intl.formatMessage({ id: 'ateDataFinal' }) +
              ': ' +
              moment(obj).format('MM/YYYY')
            );

          case 'tipoPeriodoDataTermino':
            if (obj && Number(obj.id) === 1) return;
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataTermino' })
              ) +
              ': ' +
              obj.descricao
            );

          case 'dataTerminoDe':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataTermino' })
              ) +
              ' - ' +
              intl.formatMessage({ id: 'deDataInicial' }) +
              ': ' +
              moment(obj).format('MM/YYYY')
            );

          case 'dataTerminoAte':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataTermino' })
              ) +
              ' - ' +
              intl.formatMessage({ id: 'ateDataFinal' }) +
              ': ' +
              moment(obj).format('MM/YYYY')
            );

          case 'farolAcumulado':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'farolAcumulado' },
                { farolAcumulado: resources.farolAcumulado }
              )
            );
          case 'tags':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
            );
          case 'statusBaseline':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelStatusBaseLine' })
              ) +
              ': ' +
              obj.descricao
            );
          case 'tipoCondicional':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'condicional' })) +
              ': ' +
              obj.descricao
            );
          case 'riscosVinculados':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelRiscosVinculados' },
                  { riscos: resources.riscos }
                )
              ) +
              ': ' +
              label
            );

          case 'responsaveisPeloInput':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'responsaveisPeloInput' },
                  { responsaveis: resources.responsaveis }
                )
              ) +
              ': ' +
              label
            );

          case 'controles':
          case 'pontosDeControle': {
            const descricoes = obj?.length
              ? obj.map((item) => item.descricao).join(', ')
              : '';

            return (
              capitalizeFirstLetter(resources.pontosdecontrole) +
              ': ' +
              descricoes
            );
          }

          case 'tratamentoRisco':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'tratamento' })) +
              ': ' +
              label
            );

          case 'responsavelItem':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'responsavelItem' },
                  { responsavel: resources.responsavel, item: resources.item }
                )
              ) +
              ': ' +
              label
            );

          case 'statusAcaoList':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'statusAcao' },
                  { acao: resources.acao }
                )
              ) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.descricao;
                      })
                      .join(', ')
                  : obj.descricao
                : '')
            );

          case 'auditorias':
            return (
              capitalizeFirstLetter(resources.auditorias) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.nome;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'responsaveisSimplificado':
            return (
              capitalizeFirstLetter(resources.responsaveis) +
              ': ' +
              (obj
                ? objArray
                  ? obj
                      .map((item) => {
                        return item.nome;
                      })
                      .join(', ')
                  : obj.nome
                : '')
            );
          case 'tipoFiltroDataPeriodoAuditoriaRisco':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  {
                    id: 'tipoFiltroDataPeriodoAuditoriaRisco',
                  },
                  { auditoria: resources.auditoria }
                )
              ) +
              ': ' +
              label
            );
          case 'statusReuniao':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({
                  id: 'status',
                })
              ) +
              ': ' +
              label
            );
          case 'planoContas':
            return capitalizeFirstLetter(
              resources.planodecontas + ': ' + obj.nome
            );
          case 'areaCardMetas':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'areaCardMetas' },
                { area: resources.area, cardmetas: resources.cardmetas }
              ) +
                ': ' +
                label
            );
          case 'tipoFiltroCardMetas':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'label.tipoFiltro' }) + ': ' + label
            );
          case 'tipoCargo':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'tipoCargo' },
                { cargo: resources.cargo }
              ) +
                ': ' +
                label
            );
          case 'areaVinculo':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'areaVinculadaFuncao' },
                { area: resources.area, funcao: resources.funcao }
              ) +
                ': ' +
                obj.nome
            );
          case 'exibirApenasProjetosLicoes':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'exibirProjetosLicoes' },
                { projetos: resources.projetos }
              )
            );
          case 'statusTAP':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'filtroStatusTAP' }) + ': ' + label
            );
          case 'statusTEP':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'filtroStatusTEP' }) + ': ' + label
            );
          case 'exibirImpactosIndiretos':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'label.exibirImpactosIndiretos' })
            );
          case 'temaEstrategico':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'label.temaEstrategico' }) + ': ' + label
            );
          case 'incluirAreasSubordinadas':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.incluirAreasSubordinadas' },
                { areas: resources.areas }
              )
            );
          case 'exibirIndicador':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirIndicador' },
                { indicador: resources.indicador }
              )
            );
          case 'exibirObjetivo':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirObjetivoEstrategico' },
                { objetivoestrategico: resources.objetivoestrategico }
              )
            );
          case 'exibirProjeto':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirProjeto' },
                { projeto: resources.projeto }
              )
            );
          case 'mostrarTabela':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.mostrarTabelaDeValores' },
                { valores: resources.valores }
              )
            );
          case 'incluirCentrosCustoSubordinados':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.centrosSubordinados' },
                { centroscusto: resources.centroscusto }
              )
            );
          case 'exibirCodigoImportacao':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirCodigoImportacaoPacoteCentroCusto' },
                { centroscusto: resources.centroscusto }
              )
            );
          case 'exibirPacotesDespesa':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'label.exibirPacotesContasDespesa' })
            );
          case 'exibirPacotesReceita':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'label.exibirPacotesContasReceita' })
            );
          case 'tipoCombinacaoValor':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'label.tipoCombinacaoValor' }) +
                ': ' +
                label
            );
          case 'centroCusto':
            return (
              capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'centroCusto' },
                  { centrocusto: resources.centrocusto }
                )
              ) +
              ': ' +
              label
            );
          case 'exibirIndicadorPreco':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirIndicadordePreco' },
                { indicadordepreco: resources.indicadordepreco }
              )
            );
          case 'exibirIndicadorConsumo':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirIndicadorConsumo' },
                { indicadordeconsumo: resources.indicadordeconsumo }
              )
            );
          case 'exibirIndicadorFinal':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.exibirIndicadorFinal' },
                { indicadorfinal: resources.indicadorfinal }
              )
            );
          case 'tipoFluxoAprovacao':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'tipo' })) +
              ': ' +
              label
            );
          case 'indicador':
            return (
              capitalizeFirstLetter(resources.indicador + ': ' + obj.nome) +
              ': ' +
              label
            );
          case 'dataInicioValoresVazios':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'dataInicio' })) +
              ': ' +
              label
            );
          case 'dataTerminoValoresVazios':
            return (
              capitalizeFirstLetter(intl.formatMessage({ id: 'dataTermino' })) +
              ': ' +
              label
            );
          case 'valorVazioRealizado':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'valorRealizado' })
            );
          case 'valorVazioRealizadoAcumulado':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'valorRealizadoAcumulado' })
            );
          case 'valorVazioMeta':
            return capitalizeFirstLetter(
              intl.formatMessage({ id: 'valorMeta' }, { meta: resources.meta })
            );
          case 'valorVazioMetaAcumulado':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'valorMetaAcumulado' },
                { meta: resources.meta }
              )
            );
          case 'incluirColaboradoresSubordinados':
            return capitalizeFirstLetter(
              intl.formatMessage(
                {
                  id: 'incluirColaboradoresSubordinados',
                },
                {
                  colaboradores: resources.colaboradores,
                }
              )
            );
          case 'exibirApenasAuditoriasComPontosAuditoria':
            return capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelExibirApenasAuditoriasComPontosAuditoria' },
                {
                  auditoria: resources.auditoria,
                  auditorias: resources.auditorias,
                }
              )
            );
          case 'isWidget':
            return '';
          case 'descricaoPontoAuditoria':
            return capitalizeFirstLetter(
              intl.formatMessage({
                id: 'labelDescricaoPontoAuditoria',
              })
            );
          case 'causaRaiz':
            return capitalizeFirstLetter(
              intl.formatMessage({
                id: 'labelCausaRaiz',
              })
            );
          case 'analiseAuditor':
            return capitalizeFirstLetter(
              intl.formatMessage({
                id: 'labelAnaliseAuditor',
              })
            );
          case 'recomendacao':
            return capitalizeFirstLetter(
              intl.formatMessage({
                id: 'labelRecomendacao',
              })
            );
          case 'workItem':
            return (
              capitalizeFirstLetter(
                intl.formatMessage({ id: 'tipoWorkItem' })
              ) +
              ': ' +
              label
            );
          default:
            return label
              ? intl.formatMessage({ id: objectIndex[index] }) + ': ' + label
              : intl.formatMessage({ id: objectIndex[index] });
        }
    } else {
      switch (finalLabel) {
        case 'labelPesquisaClima':
          return capitalizeFirstLetter(resources.pesquisas) + ': ' + label;
        case 'farolAcumulado':
          return capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'farolAcumulado' },
              { farolAcumulado: resources.farolAcumulado }
            )
          );
        case 'farol':
          return capitalizeFirstLetter(resources.farol) + ': ' + label;
        case 'labelRiscoAtrelado':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelRiscoAtrelado' },
                { risco: resources.risco }
              )
            ) +
            ': ' +
            label
          );
        case 'labelRiscosVinculados':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelRiscosVinculados' },
                { riscos: resources.riscos }
              )
            ) +
            ': ' +
            label
          );
        case 'labelFarolLimites':
          return (
            capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelFarolLimites' })
            ) +
            ': ' +
            label
          );
        case 'areasDoRisco':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'areasDoRisco' },
                { areas: resources.areas, risco: resources.risco }
              )
            ) +
            ': ' +
            label
          );
        case 'digitador':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'digitador' },
                { digitador: resources.digitador }
              )
            ) +
            ': ' +
            label
          );
        case 'areasDoControle':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'areasDoControle' },
                {
                  areas: resources.areas,
                  pontodecontrole: resources.pontodecontrole,
                }
              )
            ) +
            ': ' +
            label
          );

        case 'tags':
          return (
            capitalizeFirstLetter(
              intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
            ) +
            ': ' +
            label
          );

        case 'dataInicio':
          return (
            capitalizeFirstLetter(intl.formatMessage({ id: 'dataInicio' })) +
            ': ' +
            (this.props.dateFormat
              ? moment(obj).format(this.props.dateFormat)
              : label)
          );

        case 'dataTermino':
          return (
            capitalizeFirstLetter(intl.formatMessage({ id: 'dataTermino' })) +
            ': ' +
            (this.props.dateFormat
              ? moment(obj).format(this.props.dateFormat)
              : label)
          );

        case 'deDataInicial':
        case 'deDataInicialExecucao':
        case 'deDataInicialConclusao':
          return (
            capitalizeFirstLetter(intl.formatMessage({ id: 'deDataInicial' })) +
            ': ' +
            moment(obj).format('MM/yyyy')
          );

        case 'ateDataFinal':
        case 'ateDataFinalExecucao':
        case 'ateDataFinalConclusao':
          return (
            capitalizeFirstLetter(intl.formatMessage({ id: 'ateDataFinal' })) +
            ': ' +
            moment(obj).format('MM/yyyy')
          );

        case 'tipoConsolidacaoAcumuladoMeta':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'tipoConsolidacaoAcumuladoMeta' },
                { meta: resources.meta }
              )
            ) +
            ': ' +
            label
          );

        case 'label.tipoConsolidacaoMeta':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.tipoConsolidacaoMeta' },
                { meta: resources.meta }
              )
            ) +
            ': ' +
            label
          );

        case 'diasParaVencimento':
          return (
            capitalizeFirstLetter(
              intl.formatMessage({ id: 'diasParaVencimento' })
            ) +
            ': ' +
            label
          );

        case 'auditorias':
          return (
            capitalizeFirstLetter(resources.auditorias) +
            ': ' +
            (obj
              ? objArray
                ? obj
                    .map((item) => {
                      return item.nome;
                    })
                    .join(', ')
                : obj.nome
              : '')
          );
        case 'apenasDiasUteis':
          return (
            capitalizeFirstLetter(
              intl.formatMessage({ id: 'apenasDiasUteis' })
            ) +
            ': ' +
            label
          );
        case 'cargo':
          return capitalizeFirstLetter(resources.cargo) + ': ' + label;
        case 'areasInteresse':
          return (
            capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'areasInteresse' },
                { areas: resources.areas }
              )
            ) +
            ': ' +
            label
          );
        case 'tipoCadastro':
          return (
            capitalizeFirstLetter(intl.formatMessage({ id: 'tipoCadastro' })) +
            ': ' +
            label
          );
        case 'visualizarUtilizandoAsCestasComissao':
          return capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'visualizarUtilizandoAsCestasComissao' },
              { comissao: resources.comissao }
            )
          );
        case 'visualizarValorScoreForecast':
          return capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'visualizarValorScoreForecast' },
              { valorestimado: resources.valorestimado }
            )
          );
      }
    }

    return check
      ? intl.formatMessage(
          { id: finalLabel },
          {
            centroscusto: resources.centroscusto,
            auditoria: resources.auditoria,
            avaliacao: resources.avaliacao,
          }
        )
      : finalLabel
      ? intl.formatMessage(
          { id: finalLabel },
          {
            centrocusto: resources.centrocusto,
            responsavel: capitalizeFirstLetter(resources.responsavel),
            auditoria: resources.auditoria,
            projeto: capitalizeFirstLetter(resources.projeto),
            avaliacao: resources.avaliacao,
          }
        ) +
        ': ' +
        label
      : label;
  }

  handleFarol(farol) {
    return farol.cor == null ? (
      <LucideIcon className="d-flex" icon={farol.icone} />
    ) : (
      <SvgIcon
        className="d-flex mr-n1"
        style={{ marginTop: -2 }}
        icon={farol.icone}
        color={farol.cor}
      />
    );
  }

  removeChip(filter, index, indexCampo, campoCustomizado) {
    const { selectedFilter } = this.state;

    const objectIndex = Object.keys(filter);

    const field = objectIndex[indexCampo != null ? indexCampo : index];

    if (this.props.preventRemoveFilterChip) {
      const prevent = this.props.preventRemoveFilterChip(
        field,
        this.state.selectedFilter
      );

      if (prevent) return;
    }

    this.props.onRemoveFilterChip &&
      this.props.onRemoveFilterChip(field, campoCustomizado);

    if (this.isCampoCustomizado(field)) {
      const listaAtual = selectedFilter[field] || [];
      const list = [...listaAtual];

      list.splice(index, 1);

      this.setState(
        {
          selectedFilter: {
            ...this.state.selectedFilter,
            [field]: list,
          },
          updateProps: false,
        },
        async () => {
          await this.saveFilter();

          this.props.onChangeUrl &&
            this.props.onChangeUrl(this.state.selectedFilter);
        }
      );
    } else {
      let currentFilter = {
        ...this.state.selectedFilter,
        [field]: selectedFilter[field] === true ? false : null,
      };

      if (this.props.adjustFilterOnRemoveChip) {
        currentFilter = this.props.adjustFilterOnRemoveChip(
          field,
          currentFilter,
          this.state.selectedFilter
        );
      }

      this.setState(
        {
          selectedFilter: currentFilter,
        },
        async () => {
          await this.saveFilter();

          this.props.onChangeUrl && this.props.onChangeUrl(currentFilter);
        }
      );
    }
  }

  async saveFilter() {
    let { filtroId, currentFilter, onRemoveSaveFilter = true } = this.props;

    if (onRemoveSaveFilter && filtroId) {
      const valor = this.state.selectedFilter;
      const id = currentFilter?.id ?? 0;
      const nome = currentFilter?.nome ?? null;
      const ehFavorito = currentFilter?.ehFavorito ?? false;

      let novoFiltro = {
        id: id,
        valor: valor,
        nome: nome,
        ehFavorito: ehFavorito,
      };

      if (this.props.getFiltroFavorito) {
        this.props.getFiltroFavorito(id, ehFavorito, filtroId);
      }

      await http
        .post(`/FiltroColaborador/${filtroId}/SalvarFiltro`, {
          model: novoFiltro,
          filtroId: filtroId,
        })
        .then((response) => {
          const url = new URL(window.location.href);

          if (url.searchParams.has('filtroFavoritoId')) {
            url.searchParams.delete('filtroFavoritoId');
            window.location.replace(url.toString());
          }

          this.props.onSearch && this.props.onSearch(response.data, true);
          this.setState({
            updateProps: false,
          });
        });
    } else {
      this.props.onSearch &&
        this.props.onSearch({ ...this.state.selectedFilter }, true);
      this.setState({
        updateProps: false,
      });
    }
  }

  isNotBoolean(filtro) {
    return (
      filtro !== true &&
      filtro !== false &&
      filtro !== 'true' &&
      filtro !== 'false'
    );
  }

  renderChip(filtro, index, indexCampo) {
    let { selectedFilter } = this.state;

    if (this.props.selectedFilter && selectedFilter === null) {
      selectedFilter = this.props.selectedFilter;
    }

    let chipType = null;
    let labelType;

    const objectIndex = Object.keys(selectedFilter);

    const isStatusTEP = objectIndex[index] === 'statusTEP';

    const showChip = this.form.getModel(
      objectIndex[indexCampo ?? index]
    ).showchip;

    if (showChip === false) return;

    if (filtro != null && filtro.icone != null && !isStatusTEP) {
      chipType = this.handleFarol(filtro);

      labelType = this.handleLabel(
        filtro,
        index,
        selectedFilter,
        !filtro.descricao
      );
    } else if (
      indexCampo != null &&
      this.isCampoCustomizado(objectIndex[indexCampo])
    ) {
      labelType = this.handleLabel(
        filtro,
        index,
        selectedFilter,
        null,
        indexCampo
      );
    } else if (filtro != null && filtro != '' && this.isNotBoolean(filtro)) {
      labelType = this.handleLabel(filtro, index, selectedFilter);
    } else if (filtro == true || filtro == 'true') {
      chipType = <LucideIcon className="d-flex" icon="check" />;
      labelType = this.handleLabel(filtro, index, selectedFilter, true);
    }

    if (chipType == null && labelType == null) {
      return;
    }

    const chipKey =
      indexCampo != null
        ? `${objectIndex[indexCampo]}-${filtro.campo?.id ?? filtro.id ?? index}`
        : objectIndex[index];

    return (
      filtro &&
      labelType &&
      !labelType.includes('undefined') && (
        <div
          key={chipKey}
          style={{
            marginRight: 10,
          }}
        >
          <Tooltip text={labelType} maxWidth="none">
            <Chip
              Icon={chipType}
              style={{
                maxWidth: '650px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                deletableColorPrimary: 'green',
              }}
              label={labelType}
              onDelete={() =>
                this.removeChip(selectedFilter, index, indexCampo, filtro)
              }
            />
          </Tooltip>
        </div>
      )
    );
  }

  scroll(scrollOffset) {
    if (this.divScroll.current) {
      const newValue = this.divScroll.current.scrollLeft + scrollOffset;
      const maxValue =
        this.divScroll.current.scrollWidth - this.divScroll.current.clientWidth;

      this.divScroll.current.scrollLeft = newValue;

      if (newValue > 0 && maxValue != 0) {
        this.setState({
          showLeftArrow: true,
        });
      } else {
        this.setState({
          showLeftArrow: false,
        });
      }

      if (newValue >= maxValue || maxValue == 0) {
        this.setState({
          showRightArrow: false,
        });
      } else {
        this.setState({
          showRightArrow: true,
        });
      }
    }
  }

  checkScroll() {
    if (this.divScroll.current) {
      const maxValue =
        this.divScroll.current.scrollWidth - this.divScroll.current.clientWidth;

      if (maxValue == 0) {
        this.setState({
          showRightArrow: false,
          showLeftArrow: false,
        });
      } else {
        this.setState({
          showRightArrow: true,
        });
      }
    }
  }

  render() {
    const { intl } = this.props;

    let { selectedFilter, showLeftArrow, showRightArrow } = this.state;

    let filtroList =
      selectedFilter &&
      (selectedFilter.valor != null
        ? Object.values(selectedFilter.valor)
        : Object.values(selectedFilter));

    let objectIndex =
      selectedFilter &&
      (selectedFilter.valor != null
        ? Object.getOwnPropertyNames(selectedFilter.valor)
        : Object.getOwnPropertyNames(selectedFilter));

    return (
      <div className="w-100 position-relative">
        <div
          className="d-flex flex-nowrap chips-wrapper mx-2 h-100 align-items-center"
          ref={this.divScroll}
        >
          {filtroList &&
            filtroList.map((filtro, index) =>
              filtro &&
              filtro.length > 0 &&
              this.isCampoCustomizado(objectIndex[index])
                ? filtro.map(
                    (campo, indexCampo) =>
                      (this.props.isCustomFieldSelected
                        ? this.props.isCustomFieldSelected(campo)
                        : campo.valor ||
                          (campo.campo.valores && campo.campo.multiSelecao)) &&
                      this.renderChip(campo, indexCampo, index)
                  )
                : this.renderChip(filtro, index)
            )}

          {showLeftArrow && (
            <div
              id="filter-left-arrow"
              title={capitalizeFirstLetter(
                intl.formatMessage({
                  id: 'label.anterior',
                })
              )}
              className="position-absolute d-flex align-items-center h-100 justify-center"
              style={{
                left: 0,
                color: '#868282',
                border: 'none',
                padding: '1rem 0.5rem',
                cursor: 'pointer',
                width: 55,
              }}
              onClick={() => this.scroll(-150)}
            >
              <LucideIcon style={{ zIndex: 2 }} size={35} icon="chevron-left" />
            </div>
          )}

          {showRightArrow && (
            <div
              id="filter-right-arrow"
              title={capitalizeFirstLetter(
                intl.formatMessage({
                  id: 'label.proximo',
                })
              )}
              className="position-absolute d-flex align-items-center h-100 justify-center"
              style={{
                right: 0,
                color: '#868282',
                border: 'none',
                padding: '1rem 0.5rem',
                cursor: 'pointer',
                width: 55,
              }}
              onClick={() => this.scroll(150)}
            >
              <LucideIcon
                style={{ zIndex: 2 }}
                size={35}
                icon="chevron-right"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    idioma: state.user.idioma,
    locale: state.user.locale,
  };
}
export default injectIntl(connect(mapStateToProps)(FiltroChip));
